import React, { useState } from "react"
import { createPortal } from "react-dom"

import { REAL_TIME_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import HistoryTable from "./Table"
import { Grid } from "@mui/material"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import HistoryDemoData from "./VirtualTour/DemoData"
import { isTourDemoActive } from "@signals/app"


export default function HistoryPage() {
	const [tourActive, setTourActive] = useState(false)

	return <PageWrapper
		head={`DS Rentacar | ${REAL_TIME_ROUTES.HISTORY_TITLE}`}
		title={REAL_TIME_ROUTES.HISTORY_TITLE}
		subtitle={REAL_TIME_ROUTES.HISTORY_SUBTITLE}
		actions={<VirtualTourButton onClick={() => { setTourActive(true); isTourDemoActive.value = true }} />}
	>
		<Grid container>
			<Grid item xs={12}>
				<HistoryTable/>
			</Grid>
		</Grid>
		{tourActive && <HistoryDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
			document.body
		)}
	</PageWrapper>
}
